import { render } from "./RestaurantVoucherLoader.vue?vue&type=template&id=db05065e"
import script from "./RestaurantVoucherLoader.vue?vue&type=script&lang=js"
export * from "./RestaurantVoucherLoader.vue?vue&type=script&lang=js"

import "./RestaurantVoucherLoader.vue?vue&type=style&index=0&id=db05065e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__